"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./index.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('value', 'setValue', null), recompose_1.pure);
var images = {
    PRINT_ORDERS: '/assets/features/print_orders.svg',
    AUTOMATIC_PRINT_ORDERS: '/assets/features/automatic_order_addons.svg',
    VIEWER_2D: '/assets/features/2d_viewer.svg',
    FILESTAB: '/assets/features/filestab.svg',
    FILESTAB_PLUS: '/assets/features/filestab_plus.svg',
    SOKOBID: '/assets/features/sokobid.svg',
    CONGRID: '/assets/features/congrid.svg',
    SOKOSITE: '/assets/features/sokosite.svg',
    PDFCOMPARE: '/assets/features/pdfcompare.svg',
    MODELSPACE: '/assets/features/modelspace.svg',
    SUBPROJECT: '/assets/features/subproject.svg',
    VEKTORIO: '/assets/features/vektorio-logo.svg'
};
exports.default = enhance(function (props) { return (React.createElement("div", { className: "feature-card" },
    React.createElement("div", { className: "image" },
        React.createElement("img", { src: images[props.feature.constant] })),
    React.createElement("div", { className: "information" },
        React.createElement("div", { className: "name-modify" },
            React.createElement("label", { className: "name" }, (0, translation_1.getLocalization)('features/' + props.feature.constant + '/name')),
            props.toggleSettings &&
                (props.settingsDisabled ? (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("features/".concat(props.type.toLowerCase(), "/config/tooltip"))) },
                    React.createElement(sok_ui_1.Icon, { className: 'fa-cog disabled' }))) : (React.createElement(sok_ui_1.Icon, { onClick: function () { return props.toggleSettings && props.toggleSettings(true); }, className: 'fa-cog' })))),
        React.createElement("div", { className: "details" },
            React.createElement("div", { className: "checkbox" },
                React.createElement(sok_ui_1.Input, { type: "checkbox", name: "print-orders", label: "", onChange: function (e) {
                        if (e.target.checked) {
                            props.select(props.feature);
                        }
                        else {
                            props.unselect(props.feature);
                        }
                    }, value: props.feature.enabled })),
            React.createElement("div", { className: "price" },
                React.createElement(sok_ui_1.TextInput, { type: "text", className: "print-orders-price", value: props.value !== null ? props.value : props.feature.price, onChange: function (e) {
                        if (/^([0-9]*)$/i.test(e.target.value)) {
                            props.setValue(e.target.value);
                        }
                    }, onBlur: function (e) {
                        var price = parseInt(e.target.value, 10);
                        !isNaN(price) && props.updatePrice(props.feature.uuid, price);
                        props.setValue(null);
                    } })))))); });
